export default __webpack_public_path__ + "static/media/confetti.e7368476.svg";